export default function changeWithErrorStatus({ change, error }) {
  return {
    ...change,
    newCell: {
      ...change.previousCell,
      error,
    }
  }
}
